import React from 'react';

type GradeType = 'A' | 'B' | 'C' | 'D';

interface GradeBadgeProps {
  grade: GradeType;
}

const GRADE_CONFIG: Record<GradeType, string> = {
  A: 'badge-grade-a',
  B: 'badge-grade-b',
  C: 'badge-grade-c',
  D: 'bg-red-500/10 text-red-400 border border-red-500/20 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold',
};

export default function GradeBadge({ grade }: GradeBadgeProps) {
  return (
    <span className={GRADE_CONFIG[grade]}>
      {grade} Grade
    </span>
  );
}